import AbstractModel from './AbstractModel';

class CountryModel extends AbstractModel {}

export default CountryModel;
